import styled from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import { getSafeAreaValue } from '../../../styled/theme/helpers/getSafeAreaValue';

export const ResidencesMapContainer = styled.div<{
  $markersLoading: boolean;
}>`
  opacity: ${({ $markersLoading }) => ($markersLoading ? 0.9 : 1)};
  transition: opacity 0.2s ease-in-out;
  margin-bottom: ${({ theme }) => getSafeAreaValue(theme, 'bottom', 0, 20)};

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 0;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    margin-bottom: 140px;
  }
`;
